import { useEffect, useState, type PropsWithChildren } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { api } from '../api'

export function Layout({ children }: PropsWithChildren) {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  useEffect(() => { setOpen(false); if (!location.pathname.startsWith('/admin')) void api.metric(location.pathname).catch(() => undefined) }, [location.pathname])
  return <div className="site-shell">
    <header className="site-header">
      <NavLink className="brand" to="/" aria-label="Chatroid home"><img src="/assets/jeku-logo.png" alt=""/><span>Chatroid, LLC</span></NavLink>
      <button className="menu-toggle" aria-label="Toggle menu" aria-expanded={open} onClick={() => setOpen(value => !value)}><span/><span/></button>
      <nav className={open ? 'main-nav open' : 'main-nav'} aria-label="Main navigation">
        <div className="nav-pill"><NavLink to="/" end>Company</NavLink><NavLink to="/projects">Projects</NavLink><NavLink to="/principles">Principles</NavLink></div>
        <NavLink className="button ghost" to="/contact">Contact</NavLink>
        <a className="button primary compact" href="https://jeku.ai" target="_blank" rel="noreferrer">Explore jeku.ai <span aria-hidden="true">↗</span></a>
      </nav>
    </header>
    <main>{children}</main>
    <footer><div className="footer-brand"><img src="/assets/jeku-logo.png" alt=""/><div><strong>Chatroid, LLC</strong><span>Independent software company</span></div></div><div className="footer-links"><NavLink to="/projects">Projects</NavLink><NavLink to="/principles">Principles</NavLink><NavLink to="/contact">Contact</NavLink><NavLink to="/admin">Admin</NavLink></div><p>© {new Date().getFullYear()} Chatroid, LLC. All rights reserved.</p></footer>
  </div>
}
